import React from 'react';

const formatDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('sv-SE');
};

const normalizeList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string' && value.trim()) return [value.trim()];
  return [];
};

const QuestionInsightPanel = ({ question, onDisable }) => {
  if (!question) return null;

  const generationProvider = question.aiGenerationProvider || question.provider || null;
  const generationModel = question.aiGenerationModel || question.model || null;
  const generationPromptVariant = question.aiGenerationPromptVariant || question.generationPromptVariant || null;
  const validationResult = question.aiValidationResult || null;
  const validationProvider =
    validationResult?.validationContext?.validationProvider ||
    validationResult?.validationProvider ||
    null;
  const validationPromptVariant =
    validationResult?.validationContext?.validationPromptVariant ||
    question.aiValidationPromptVariant ||
    null;
  const validationConfidence = validationResult?.confidence;
  const validationFeedback = validationResult?.feedback;

  const categories = normalizeList(question.categories);
  const ageGroups = normalizeList(question.ageGroups);
  const targetAudience = question.targetAudience || null;
  const difficulty = question.difficulty || null;
  const timeSensitive = question.timeSensitive === true;
  const bestBeforeAt = formatDate(question.bestBeforeAt);
  const aiValidated = question.aiValidated === true || question.validated === true;
  const aiValidatedAt = formatDate(question.aiValidatedAt || question.validatedAt);

  return (
    <div className="mt-3 rounded-lg border border-slate-700 bg-slate-900/80 p-3 text-xs text-slate-200 space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-slate-300 font-semibold">🧠 Varför denna fråga?</span>
        {onDisable && (
          <button
            type="button"
            onClick={onDisable}
            className="text-xs text-slate-400 hover:text-slate-200 underline"
          >
            Stäng AI‑hjälp
          </button>
        )}
      </div>
      <div className="space-y-1">
        <div>
          Skapad av: {generationProvider ? generationProvider.toUpperCase() : 'Manuellt'}
          {generationModel ? ` · ${generationModel}` : ''}
          {generationPromptVariant ? ` · variant ${generationPromptVariant}` : ''}
        </div>
        <div>
          Validering: {aiValidated ? 'Godkänd' : 'Inte validerad'}
          {validationProvider ? ` · ${validationProvider.toUpperCase()}` : ''}
          {validationConfidence != null ? ` · ${validationConfidence}%` : ''}
          {aiValidatedAt ? ` · ${aiValidatedAt}` : ''}
          {validationPromptVariant ? ` · variant ${validationPromptVariant}` : ''}
        </div>
        {validationFeedback && (
          <div className="text-slate-300">AI‑feedback: {validationFeedback}</div>
        )}
      </div>
      <div className="space-y-1">
        {categories.length > 0 && <div>Kategori: {categories.join(', ')}</div>}
        {ageGroups.length > 0 && <div>Ålder: {ageGroups.join(', ')}</div>}
        {targetAudience && <div>Målgrupp: {targetAudience}</div>}
        {difficulty && <div>Nivå: {difficulty}</div>}
        <div>
          Aktualitet: {timeSensitive ? 'Tidskänslig' : 'Evergreen'}
          {bestBeforeAt ? ` · Bäst före ${bestBeforeAt}` : ''}
        </div>
      </div>
    </div>
  );
};

export default QuestionInsightPanel;
